import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCPrincessSyllabob extends NPC {
    constructor() {
        super(definitions.NPC_ID.PRINCESS_SYLLABOB);

        this.collisionRadius = 34;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -38;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_princess_syllabob_angle_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.8, new PIXI.Point(0, -6));
        this.animateIdle(0.5);
    }

    onViewAdded() {
        super.onViewAdded();

        this._status.x += 24;
    }
}